var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user.isAdmin
    ? _c("div", { staticClass: "container" }, [
        _c(
          "h1",
          { staticClass: "mt-2 mb-4 font-sans-bold" },
          [
            _vm._v("\n      Your Profile "),
            _c("MasqueradeAsUser", { attrs: { user: _vm.user } }),
          ],
          1
        ),
        _vm._v(" "),
        _c("form", [
          _c("div", { staticClass: "mb-12" }, [
            _c("label", { attrs: { for: "first_name" } }, [
              _vm._v("\n                First name\n            "),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.first_name,
                  expression: "form.first_name",
                },
              ],
              attrs: {
                id: "first_name",
                type: "text",
                name: "first_name",
                autocomplete: "off",
              },
              domProps: { value: _vm.form.first_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "first_name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("first_name"),
                    expression: "errors.has('first_name')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("first_name")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _c("label", { attrs: { for: "last_name" } }, [
              _vm._v("\n                Last name\n            "),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.last_name,
                  expression: "form.last_name",
                },
              ],
              attrs: {
                id: "last_name",
                type: "text",
                name: "last_name",
                autocomplete: "off",
              },
              domProps: { value: _vm.form.last_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "last_name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("last_name"),
                    expression: "errors.has('last_name')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("last_name")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _c("label", { attrs: { for: "email" } }, [
              _vm._v("\n                Email\n            "),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|email",
                  expression: "'required|email'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.email,
                  expression: "form.email",
                },
              ],
              attrs: {
                id: "email",
                type: "email",
                name: "email",
                autocomplete: "off",
              },
              domProps: { value: _vm.form.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "email", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("email"),
                    expression: "errors.has('email')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("email")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _c("label", { attrs: { for: "squadupUserId" } }, [
              _vm._v("\n                Squadup User Id\n            "),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.squadupUserId,
                  expression: "form.squadupUserId",
                },
              ],
              attrs: {
                id: "squadupUserId",
                type: "text",
                name: "squadupUserId",
                autocomplete: "off",
              },
              domProps: { value: _vm.form.squadupUserId },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "squadupUserId", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "min:8|upperCase|number|lowerCase",
                  expression: "'min:8|upperCase|number|lowerCase'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.password,
                  expression: "form.password",
                },
              ],
              attrs: {
                id: "password",
                type: "password",
                name: "password",
                autocomplete: "off",
              },
              domProps: { value: _vm.form.password },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "password", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("password"),
                    expression: "errors.has('password')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("password")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-12" }, [
            _c("div", { staticClass: "select-box" }, [
              _c(
                "label",
                {
                  staticClass: "text-base font-normal",
                  attrs: { for: "make-admin" },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.shouldBeAdmin,
                        expression: "form.shouldBeAdmin",
                      },
                    ],
                    attrs: { id: "make-admin", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.form.shouldBeAdmin)
                        ? _vm._i(_vm.form.shouldBeAdmin, null) > -1
                        : _vm.form.shouldBeAdmin,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.form.shouldBeAdmin,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "shouldBeAdmin",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "shouldBeAdmin",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "shouldBeAdmin", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "check inline-block mr-2" }),
                  _vm._v(" Make user a system admin\n            "),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.validateUpdate.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n            Save\n        ")]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "password" } }, [
      _vm._v("\n                Change Password\n                "),
      _c("div", { staticClass: "text-sm font-sans-book" }, [
        _c("span", { staticClass: "font-sans-bold" }, [
          _vm._v(
            "Password should contain at least 8 characters, including at least 1 lowercase letter, 1 uppercase letter, and 1 number."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }